import styled from '@emotion/styled'
import { BlockSpinner } from 'components/spinner/Spinner'
import isPropValid from '@emotion/is-prop-valid'
import { Icon } from 'components/icon'

export const SMemoryTitle = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  & input {
    color: white;
    font-weight: bold;
    background-color: transparent;
    transition: background-color 0.3s;
    &:focus,
    :hover {
      background-color: var(--c-white-transparent);
    }
  }
`

export const STitleSpinner = styled(BlockSpinner)`
  color: white;
`

export const SIconEdit = styled(Icon, { shouldForwardProp: isPropValid })<{
  hide?: boolean
}>`
  margin-left: 0.5rem;
  transition: opacity 0.3s;
  ${({ hide }) => hide && 'opacity: 0;'}
`
